export * from './deflate.types';
//# sourceMappingURL=index.js.map